import {
  LanguageContent,
  Display,
  SingleLaunchResponse
} from 'src/services/responseTypes/singleLaunchResponse';

export const getInitialDisplayLanguage = (response?: SingleLaunchResponse) => {
  return (
    response?.country_config?.language_config.display?.filter(
      (lang) => lang.is_default === true
    )?.[0]?.l_code ?? ''
  );
};
export const getInitialContentLanguage = (response?: SingleLaunchResponse) => {
  return (
    response?.country_config?.language_config?.content
      ?.filter((lang) => lang.is_default === true)
      ?.map((lang) => lang.l_code)
      .sort()
      .join(',') ?? ''
  );
};

export const getIntitialContentAndDisplayLanguage = (
  response: SingleLaunchResponse | undefined
) => {
  const displayLanguage = getInitialDisplayLanguage(response);
  const contentLanguage = getInitialContentLanguage(response);
  return { displayLanguage, contentLanguage };
};

type Language = Display | LanguageContent;
export const langaugeComparator = (lang1: Language, lang2: Language) => {
  if (lang1.is_default < lang2.is_default) return 1;
  else if (lang1.is_default > lang2.is_default) return -1;
  else {
    if (lang1.name < lang2.name) return -1;
    else if (lang1.name > lang2.name) return 1;
    return 0;
  }
};
